<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('service.detailsOfServiceInOrder') }}
        <template v-if="orderData.order_name">
          "{{ orderData.order_name }}"
        </template>
      </d-modal-title>
    </d-modal-header>

    <d-modal-body>
      <div
        v-for="(product, index) of orderData.products"
        :key="'products-services-' + index"
        class="products-services">
        <div
          v-for="(service, subindex) of product.services"
          :key="'products-services-' + index + '-' + subindex">
          <strong class="service-dates-label">{{ product.name }} - {{ service.name }}</strong>
          <dl class="service-dates-list">
            <dt>
              <span v-if="!hasWarning(service.id, 'OBTAINING')">{{ $t('service.sample.sampleReceiveDate') }}:</span>
              <span v-else class="text-danger">{{ $t('service.sample.sampleReceiveDate') }}: <i class="material-icons">warning</i></span>
            </dt>
            <dd v-if="service.obtaining_at">{{ service.obtaining_at }}</dd>
            <dd v-else>-</dd>
            <dt>
              <span v-if="!hasWarning(service.id, 'ACCEPTING')">{{ $t('service.sample.sampleAcceptDate') }}:</span>
              <span v-else class="text-danger">{{ $t('service.sample.sampleAcceptDate') }}: <i class="material-icons">warning</i></span>
            </dt>
            <dd v-if="service.accepted_at">{{ service.accepted_at }}</dd>
            <dd v-else>-</dd>
            <dt>
              <span v-if="!hasWarning(service.id, 'ENDING_PRODUCTION')">{{ $t('service.productionCompleteDate') }}:</span>
              <span v-else class="text-danger">{{ $t('service.productionCompleteDate') }}: <i class="material-icons">warning</i></span>
            </dt>
            <dd v-if="service.ended_production_at">{{ service.ended_production_at }}</dd>
            <dd v-else>-</dd>
          </dl>
        </div>
      </div>

      <h5
        v-if="orderData.services.length"
        class="products-services-separator">
        {{ $t('service.commonServices') }}
      </h5>

      <div
        v-for="(service, index) of orderData.services"
        :key="'products-services-global-' + index"
        class="products-services-global">
        <strong class="service-dates-label">{{ service.name }}</strong>
        <dl class="service-dates-list">
          <dt>
            <span v-if="!hasWarning(service.id, 'OBTAINING')">{{ $t('service.sample.sampleReceiveDate') }}:</span>
            <span v-else class="text-danger">{{ $t('service.sample.sampleReceiveDate') }}: <i class="material-icons">warning</i></span>
          </dt>
          <dd v-if="service.obtaining_at">{{ service.obtaining_at }}</dd>
          <dd v-else>-</dd>
          <dt>
            <span v-if="!hasWarning(service.id, 'ACCEPTING')">{{ $t('service.sample.sampleAcceptDate') }}:</span>
            <span v-else class="text-danger">{{ $t('service.sample.sampleAcceptDate') }}: <i class="material-icons">warning</i></span>
          </dt>
          <dd v-if="service.accepted_at">{{ service.accepted_at }}</dd>
          <dd v-else>-</dd>
          <dt>
            <span v-if="!hasWarning(service.id, 'ENDING_PRODUCTION')">{{ $t('service.productionCompleteDate') }}:</span>
            <span v-else class="text-danger">{{ $t('service.productionCompleteDate') }}: <i class="material-icons">warning</i></span>
          </dt>
          <dd v-if="service.ended_production_at">{{ service.ended_production_at }}</dd>
          <dd v-else>-</dd>
        </dl>
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'services-popup',
  props: ['orderData'],
  methods: {
    handleClose () {
      this.$bus.$emit('dashboard-service-popup-close');
    },
    hasWarning (id, type) {
      if (this.orderData.warnings.filter(warning => warning.order_service_id === id && warning.type === type).length) {
        return true;
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.products-services-separator {
  border-bottom: 1px solid #ccc;
  margin: 0;
  padding: 30px 0;
}

.service-dates {
  &-label {
    display: block;
    font-size: 14px;
    font-weight: bold;
    padding: 10px 0;
  }

  &-list {
    border-bottom: 1px solid #ccc;
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    padding-bottom: 20px;

    dt {
      width: 60%;
    }

    dd {
      width: 40%;
    }
  }
}
</style>
